import {action, makeObservable, observable} from "mobx";

export class MarketingModalStore {
  unsavedChanges = false;
  agentSelection = false;
  campaignSchedule = false;
  generalMessageModal = false;
  confirmation = false;
  editMarketing = false;
  confirmationPublish = false;
  title = "";
  message = "";
  icon = "";
  onHandleConfirm = null;
  onHandleCancel = null;

  constructor() {
    makeObservable(this, {
      unsavedChanges: observable,
      agentSelection: observable,
      campaignSchedule: observable,
      generalMessageModal: observable,
      confirmation: observable,
      editMarketing: observable,
      confirmationPublish: observable,
      title: observable,
      message: observable,
      icon: observable,
      onHandleConfirm: observable,
      onHandleCancel: observable,
      show: action,
      hide: action,
      onCancel: action,
      onConfirm: action,
    });
  }

  show({ modal, title, message, icon, onHandleConfirm, onHandleCancel }) {
    this.title = title;
    this.message = message;
    this.icon = icon;
    this.onHandleCancel = onHandleCancel;
    this.onHandleConfirm = onHandleConfirm;
    this[modal] = true;
  }

  hide(modal) {
    this[modal] = false;
  }

  onCancel(modal) {
    this.hide(modal);
    this.onHandleCancel && this.onHandleCancel();
  }
  
  onConfirm(modal) {
    this.hide(modal);
    this.onHandleConfirm && this.onHandleConfirm();
  }
}
